// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"0abc26764e4f29999307","655":"5129ee135ef8060428e2"}[chunkId] + ".js";
};